import {
  H3,
  Heading,
  Image,
  XStack,
  YStack,
} from '@bounty/creators-design-system'
import { isNotNil, prettyCurrency } from '@bounty/utils'
import BountyGift from '../assets/bounty-gift.png'

export const ProductTile = ({
  imgLink,
  productName,
  price,
  showProductTitle = false,
}: {
  imgLink?: string | null
  productName?: string | null
  price?: number | null
  showProductTitle?: boolean
}) => {
  return (
    <XStack space="$4" width="100%">
      <Image
        flexShrink={0}
        src={imgLink ?? BountyGift}
        width={90}
        height={90}
        borderRadius="$2"
      />
      <YStack
        backgroundColor={'$neutral.50'}
        flexShrink={1}
        flexGrow={1}
        justifyContent="center"
        alignItems="flex-start"
        borderColor="$neutral.200"
        borderWidth={1}
        borderRadius="$3"
        px="$4"
        py="$3"
      >
        {showProductTitle && (
          <H3 mb="$1" color="rgba(92, 225, 230, 1)" size="$sm">
            Product
          </H3>
        )}
        {productName && (
          <Heading size="$md" numberOfLines={1} flexShrink={1}>
            {productName}
          </Heading>
        )}
        <YStack pr="$3">
          {isNotNil(price) && (
            <XStack space="$1">
              <Heading size="$sm" textDecorationLine="line-through">
                {prettyCurrency(price, { precision: 2 })}
              </Heading>
              <Heading size="$sm" color="rgba(92, 225, 230, 1)">
                Free
              </Heading>
            </XStack>
          )}
        </YStack>
      </YStack>
    </XStack>
  )
}
